export default __webpack_public_path__ + "static/media/dryFood.21aa281c.png";